/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "0e940c37a8c90b98cdfdea1757bdf1cfd85b1bff";
